import ShipmentsPage from '../components/ShipmentsPage';

const ShipmentsDetails = () => <ShipmentsPage viewMode='detalle' />;

export default ShipmentsDetails;
